import { Divider, Tabs, Timeline } from "antd";
import axios from "axios";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import {
  ActiveDotIcon,
  ApproveIcon,
  BackIcon,
  CloseIcon,
  InactiveDotIcon,
  RejectedIcon,
  WaitApproveIcon,
} from "../../../asset";
import Accordion from "../../../component/accordion/Accordion";
import SecondaryButton from "../../../component/button/SecondaryButton";
import MapsSmall from "../../../component/maps/MapsSmall";
import Delete from "../../../component/modal/ModalDelete";
import ModalMaps from "../../../component/modal/ModalMaps";
import Breadcumbs from "../../../component/page-components/breadcumbs/breadcumbs";
import {
  GROLOG_BASE_URL,
  GROLOG_ORDER_URL,
  GROLOG_URL,
} from "../../../constant/apiConstant";
import { ROUTES } from "../../../constant/routeConstant";
import style from "./GromartOrderRequestList.module.css";
import moment from "moment";
import ManagementHistory from "../../../component/management-history/management-history";
import CustomDivider from "../../../component/divider/CustomDivider";
import PrimaryButton from "../../../component/button/PrimaryButton";
import ModalStartEndTrip from "../../../component/modal/ModalStartEndTrip";
import ModalSuccessAdd from "../../../component/modal/ModalSuccessAdd";
import dayjs from "dayjs";
const GromartOrderRequestDetail = () => {
  const { token, client_id, grolog_account_id, userId } = useSelector(
    (state) => state.auth
  );
  let param = `CLIENT_ID=${client_id}&RESOURCE_USER_ID=${userId}&GROLOG_ACCOUNT_ID=${grolog_account_id}`;

  const { t } = useTranslation();
  const [form, setForm] = useState({});
  const navigate = useNavigate();
  const location = useLocation();
  const [detail, setDetail] = useState([]);
  const [index, setIndex] = useState();
  const [loading, setLoading] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [isOpenMaps, setIsOpenMaps] = useState(false);
  const [SI, setSI] = useState([]);
  const [indexItem, setIndexItem] = useState();
  const [isOpenItem, setIsOpenItem] = useState(false);
  const [successModalOpen, setSuccessModalOpen] = useState(false);
  const [failedModalOpen, setFailedModalOpen] = useState(false);
  const [startOpen, setStartOpen] = useState(false);
const [endOpen, setEndOpen] = useState(false)
  const [messages, setMessages] = useState("");

  const [userManagementOpen, setUserManagementOpen] = useState(false);
  const [managementHistoryList, setManagementHistoryList] = useState([]);

  useEffect(() => {
    fetchData();
    getManagementHistoryList();
  }, []);

  const api = GROLOG_ORDER_URL;
  const doPut = async (endpoint, tkn, data, dispatch, refresh_token) => {
    const url = api + endpoint;
    const method = "PUT";
    const headers = { Authorization: tkn };
    const request = { url, method, headers, data };
    return axios(request);
  };

  const doGet = async (endpoint, tkn, params, dispatch, refresh_token) => {
    const url = api + endpoint;
    const method = "GET";
    const headers = { Authorization: tkn };
    const request = { url, method, headers, params };
    return axios(request);
  };

  const doGetBaseUrl = async (
    endpoint,
    tkn,
    params,
    dispatch,
    refresh_token
  ) => {
    const url = GROLOG_BASE_URL + endpoint;
    const method = "GET";
    const headers = { Authorization: token };
    const request = { url, method, headers, params };
    return axios(request);
  };

  const getManagementHistoryList = async () => {
    let res = await doGetBaseUrl(
      `audit/v1/grolog/audit?page=1&filter=table_name eq order, primary_key eq ${location.state}`
    );

    const data = res?.data?.payload;
    const reorderedData = [];

    for (let i = data.length - 1; i >= 0; i--) {
      const element = data[i];
      reorderedData.push(element);
    }

    setManagementHistoryList(reorderedData);
  };

  const convertTimestamp = (timestamp, isSpecific) => {
    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const monthNumbers = [
      "01",
      "02",
      "03",
      "04",
      "05",
      "06",
      "07",
      "08",
      "09",
      "10",
      "11",
      "12",
    ];

    // Extract components from the timestamp string
    const year = timestamp?.substring(0, 4);
    const month = timestamp?.substring(5, 7) - 1; // Months in JavaScript are 0-indexed
    const day = timestamp?.substring(8, 10);

    let dateFormat = new Date(year, month, day);

    if (isSpecific) {
      return `${dateFormat.getDate()}-${
        monthNames[dateFormat.getMonth()]
      }-${dateFormat.getFullYear()}`;
    } else {
      return `${dateFormat.getDate()}/${
        monthNumbers[dateFormat.getMonth()]
      }/${dateFormat.getFullYear()}`;
    }
  };

  const convertToTime = (timestamp) => {
    let time = new Date(timestamp);
    return moment(timestamp).utc().format("HH:mm");
  };

  const fetchData = async () => {
    let id = 1;
    let tkn = `Grolog2023`;
    let res = await doGet(`/gromart-order/${location.state}?${param}`, token);
    setDetail(res?.data?.payload?.data);
    setSI(res?.data?.payload?.data?.sales_invoice_list);
  };

  const clickCard = async (i, open, id) => {
    if (i === index) {
      setIsOpen(false);
      setIndex();
    } else {
      setIndex(i);
      setIsOpen(true);
      let res = await doGet(
        `/gromart-order/sales-invoice/${id}?${param}`,
        token
      );
      // setSI(res?.data?.payload?.data);
      let items = [...SI];
      items[i]["item"] = res?.data?.payload?.data;
      setSI(items);
    }
  };
  const clickCardItem = async (i, open, id) => {
    if (i === indexItem) {
      setIsOpenItem(false);
      setIndexItem();
    } else {
      setIndexItem(i);
      setIsOpenItem(isOpenItem ? false : true);
    }
  };
  console.log("check SI", SI);
  const Order = () => {
    return (
      <>
        <div className="flex flex-col gap-[40px]">
          <div>
            {/* <h3 className="font-roboto text-[20px] font-bold mb-6 mt-6">
              {t("Order Information")}
            </h3> */}
        <CustomDivider name={"Order Information"} />
            {SI?.map((el, i) => {
              return (
                <div id={i}>
                  <Accordion
                    onClick={() => clickCard(i, isOpen, el?.sales_invoice_id)}
                    index={i}
                    i={index}
                    isOpen={isOpen}
                    address={
                      el?.sales_invoice_number +
                      " - " +
                      el.total_item +
                      " item - " +
                      el?.total_weight +
                      " Kg - " +
                      el?.total_volume +
                      " m"
                    }
                    sup={<sup>3</sup>}
                    body={
                      <>
                        {isOpen === true && i === index ? (
                          <>
                            <div>
                              
            <div className="border-t border-gray-500 mt-10 w-full my-4"></div>
                              <div className="flex flex-col gap-[40px] ml-10">
                                <div>
                                  {/* <h3 className="font-roboto text-[20px] font-bold mb-6 mt-6">
                              {t("Item Detail")}
                            </h3> */}
                                  <div className="flex">
                                    {/* line one */}
                                    <div className="gap-[40px] mb-[24px]">
                                      <div className="w-[400px] mb-[24px]">
                                        <label className="font-roboto text-[14px] text-[#818181]">
                                          {t("Sales Invoice Number")}
                                        </label>
                                        <h4 className="font-roboto text-[20px] text-[#424242]">
                                          {el?.sales_invoice_number}
                                        </h4>
                                      </div>
                                      <div className="w-[400px] mb-[24px]">
                                        <label className="font-roboto text-[14px] text-[#818181]">
                                          {t("Total Weight")}
                                        </label>
                                        <h4 className="font-roboto text-[20px] text-[#424242]">
                                          {el?.total_weight} Kg
                                        </h4>
                                      </div>
                                    </div>
                                    {/* line two */}
                                    <div className="gap-[40px] mb-[24px]">
                                      <div className="w-[400px] mb-[24px]">
                                        <label className="font-roboto text-[14px] text-[#818181]">
                                          {t("Sales Invoice Date")}
                                        </label>
                                        <h4 className="font-roboto text-[20px] text-[#424242]">
                                          {el?.sales_invoice_date ? dayjs(el?.sales_invoice_date).format("YYYY/MM/DD"):""}
                                        </h4>
                                      </div>
                                      <div className="w-[400px] mb-[24px]">
                                        <label className="font-roboto text-[14px] text-[#818181]">
                                          {t("Total Volume")}
                                        </label>
                                        <h4 className="font-roboto text-[20px] text-[#424242]">
                                          {el?.total_volume} m<sup>3</sup>
                                        </h4>
                                      </div>
                                    </div>
                                    {/* line three */}
                                    <div className="gap-[40px] mb-[24px]">
                                      <div className="w-[400px] mb-[24px]">
                                        <label className="font-roboto text-[14px] text-[#818181]">
                                          {t("Total Item")}
                                        </label>
                                        <h4 className="font-roboto text-[20px] text-[#424242]">
                                          {el?.total_item}
                                        </h4>
                                      </div>
                                      <div className="w-[400px] mb-[24px]">
                                        <label className="font-roboto text-[14px] text-[#818181]">
                                          {t("Total Price")}
                                        </label>
                                        <h4 className="font-roboto text-[20px] text-[#424242]">
                                          {el?.total_price}
                                        </h4>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div>
                                {el?.item?.map((els, idx) => {
                                  return (
                                    <div id={idx} className="mr-10">
                                      <Accordion
                                        onClick={() =>
                                          clickCardItem(idx, isOpenItem)
                                        }
                                        index={idx}
                                        width="1250px"
                                        i={indexItem}
                                        isOpen={isOpenItem}
                                        address={
                                          els?.product_brand_id +
                                          " - " +
                                          els.product_name +
                                          " - " +
                                          els?.number_of_item +
                                          " Item"
                                        }
                                        body={
                                          <>
                                            {isOpenItem === true &&
                                            idx === indexItem ? (
                                              <>
                                                <div className="flex flex-col gap-[40px] ml-10 mr-10">
                                                  <div>
                                                    <CustomDivider
                                                      name={"Item Detail"}
                                                    />
                                                    <div className="flex">
                                                      {/* line one */}
                                                      <div className="gap-[40px] mb-[24px]">
                                                        <div className="w-[400px] mb-[24px]">
                                                          <label className="font-roboto text-[14px] text-[#818181]">
                                                            {t("Item Brand")}
                                                          </label>
                                                          <h4 className="font-roboto text-[20px] text-[#424242]">
                                                            {els?.product_brand
                                                              ? els?.product_brand
                                                              : els?.product_brand_id}
                                                          </h4>
                                                        </div>
                                                        <div className="w-[400px] mb-[24px]">
                                                          <label className="font-roboto text-[14px] text-[#818181]">
                                                            {t(
                                                              "Number of Item"
                                                            )}
                                                          </label>
                                                          <h4 className="font-roboto text-[20px] text-[#424242]">
                                                            {
                                                              els?.number_of_item
                                                            }{" "}
                                                            Pcs
                                                          </h4>
                                                        </div>
                                                      </div>
                                                      <div className="gap-[40px] mb-[24px]">
                                                        <div className="w-[400px] mb-[24px]">
                                                          <label className="font-roboto text-[14px] text-[#818181]">
                                                            {t("Item Name")}
                                                          </label>
                                                          <h4 className="font-roboto text-[20px] text-[#424242]">
                                                            {els?.product_name
                                                              ? els?.product_name
                                                              : "-"}
                                                          </h4>
                                                        </div>
                                                      </div>

                                                      <div className="gap-[40px] mb-[24px]">
                                                        <div className="w-[400px] mb-[24px]">
                                                          <label className="font-roboto text-[14px] text-[#818181]">
                                                            {t("Item Category")}
                                                          </label>
                                                          <h4 className="font-roboto text-[20px] text-[#424242]">
                                                            {els?.product_category
                                                              ? els?.product_category
                                                              : "-"}
                                                          </h4>
                                                        </div>
                                                      </div>
                                                    </div>

                                                    <CustomDivider
                                                      name={
                                                        "Specification Detail"
                                                      }
                                                    />
                                                    <div className="flex">
                                                      {/* line one */}
                                                      <div className="gap-[40px] mb-[24px]">
                                                        <div className="w-[400px] mb-[24px]">
                                                          <label className="font-roboto text-[14px] text-[#818181]">
                                                            {t("Width")}
                                                          </label>
                                                          <h4 className="font-roboto text-[20px] text-[#424242]">
                                                            {els?.width
                                                              ? els?.width
                                                              : 0}{" "}
                                                            mm
                                                          </h4>
                                                        </div>
                                                        <div className="w-[400px] mb-[24px]">
                                                          <label className="font-roboto text-[14px] text-[#818181]">
                                                            {t("Weigth")}
                                                          </label>
                                                          <h4 className="font-roboto text-[20px] text-[#424242]">
                                                            {els?.weigth
                                                              ? els?.weigth
                                                              : 0}{" "}
                                                            kg
                                                          </h4>
                                                        </div>
                                                        <div className="w-[400px] mb-[24px]">
                                                          <label className="font-roboto text-[14px] text-[#818181]">
                                                            {t(
                                                              "Subtotal Weight"
                                                            )}
                                                          </label>
                                                          <h4 className="font-roboto text-[20px] text-[#424242]">
                                                            {els?.subtotal_weight
                                                              ? els?.subtotal_weight
                                                              : 0}{" "}
                                                            kg
                                                          </h4>
                                                        </div>
                                                      </div>

                                                      <div className="gap-[40px] mb-[24px]">
                                                        <div className="w-[400px] mb-[24px]">
                                                          <label className="font-roboto text-[14px] text-[#818181]">
                                                            {t("Height")}
                                                          </label>
                                                          <h4 className="font-roboto text-[20px] text-[#424242]">
                                                            {els?.height
                                                              ? els?.height
                                                              : 0}{" "}
                                                            mm
                                                          </h4>
                                                        </div>
                                                        <div className="w-[400px] mb-[24px]">
                                                          <label className="font-roboto text-[14px] text-[#818181]">
                                                            {t("Volume")}
                                                          </label>
                                                          <h4 className="font-roboto text-[20px] text-[#424242]">
                                                            {els?.volume
                                                              ? els?.volume
                                                              : 0}{" "}
                                                            m <sup>3</sup>
                                                          </h4>
                                                        </div>
                                                        <div className="w-[400px] mb-[24px]">
                                                          <label className="font-roboto text-[14px] text-[#818181]">
                                                            {t(
                                                              "Subtotal Case Weight"
                                                            )}
                                                          </label>
                                                          <h4 className="font-roboto text-[20px] text-[#424242]">
                                                            {els?.subtotal_case_weight
                                                              ? els?.subtotal_case_weight
                                                              : 0}{" "}
                                                            kg
                                                          </h4>
                                                        </div>
                                                      </div>

                                                      <div className="gap-[40px] mb-[24px]">
                                                        <div className="w-[400px] mb-[24px]">
                                                          <label className="font-roboto text-[14px] text-[#818181]">
                                                            {t("Length")}
                                                          </label>
                                                          <h4 className="font-roboto text-[20px] text-[#424242]">
                                                            {els?.length
                                                              ? els?.length
                                                              : 0}{" "}
                                                            mm
                                                          </h4>
                                                        </div>
                                                        <div className="w-[400px] mb-[24px]">
                                                          <label className="font-roboto text-[14px] text-[#818181]">
                                                            {t(
                                                              "Subtotal Volume per Item"
                                                            )}
                                                          </label>
                                                          <h4 className="font-roboto text-[20px] text-[#424242]">
                                                            {els?.subtotal_volume
                                                              ? els?.subtotal_volume
                                                              : 0}{" "}
                                                            m <sup>3</sup>
                                                          </h4>
                                                        </div>
                                                      </div>
                                                    </div>

                                                    <CustomDivider
                                                      name={"Pallet"}
                                                    />
                                                    <div className="flex">
                                                      {/* line one */}
                                                      <div className="gap-[40px] mb-[24px]">
                                                        <div className="w-[400px] mb-[24px]">
                                                          <label className="font-roboto text-[14px] text-[#818181]">
                                                            {t("Pallet")}
                                                          </label>
                                                          <h4 className="font-roboto text-[20px] text-[#424242]">
                                                            {els?.is_use_pallet ===
                                                            "Y"
                                                              ? "Yes"
                                                              : "No"}
                                                          </h4>
                                                        </div>
                                                        </div>
                                                      <div className="gap-[40px] mb-[24px]">
                                                        <div className="w-[400px] mb-[24px]">
                                                          <label className="font-roboto text-[14px] text-[#818181]">
                                                            {t("Pallet Name")}
                                                          </label>
                                                          <h4 className="font-roboto text-[20px] text-[#424242]">
                                                            {els?.pallet_name
                                                              ? els?.pallet_name
                                                              : "-"}
                                                          </h4>
                                                        </div>
                                                        </div>
                                                        
                                                      <div className="gap-[40px] mb-[24px]">
                                                        <div className="w-[400px] mb-[24px]">
                                                          <label className="font-roboto text-[14px] text-[#818181]">
                                                            {t(
                                                              "Number of Item per Pallet"
                                                            )}
                                                          </label>
                                                          <h4 className="font-roboto text-[20px] text-[#424242]">
                                                            {els?.number_of_item_per_pallet
                                                              ? els?.number_of_item_per_pallet
                                                              : 0}
                                                          </h4>
                                                        </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                              </>
                                            ) : (
                                              <></>
                                            )}
                                          </>
                                        }
                                      />
                                    </div>
                                  );
                                })}
                              </div>
                            </div>
                          </>
                        ) : (
                          <></>
                        )}
                      </>
                    }
                  />
                </div>
              );
            })}
          </div>
        </div>
      </>
    );
  };

  const Delivery = () => {
    return (
      <>
        <ModalMaps
          show={isOpenMaps}
          address={detail.address}
          latitude={detail.latitude}
          longitude={detail.longitude}
          onClose={() => setIsOpenMaps(false)}
        />
        <div className="flex flex-col gap-[40px]">
          <div>
            {/* <div className="flex w-full">
            <h3 className="font-roboto text-[20px] font-bold mb-6 mt-6 mr-3 w-auto min-w-fit max-w-full">
              {t("Delivery Information")}
            </h3>
            <div className="border-t border-gray-500 mt-10 w-full my-4"></div>
            </div> */}
            <CustomDivider name={"Delivery Information"} />
            <div className="flex">
              {/* line one */}
              <div className="gap-[40px] mb-[24px]">
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-[14px] text-[#818181]">
                    {t("Delivery Type")}
                  </label>
                  <h4 className="font-roboto text-[20px] text-[#424242]">
                    {detail?.delivery_type ? detail?.delivery_type : "-"}
                  </h4>
                </div>
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-[14px] text-[#818181]">
                    {t("Arrived at Depot")}
                  </label>
                  <h4 className="font-roboto text-[20px] text-[#424242]">
                    {detail?.arrived_at_depot ? detail?.arrived_at_depot : "-"}
                  </h4>
                </div>
              </div>
              <div className="gap-[40px] mb-[24px]">
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-[14px] text-[#818181]">
                    {t("Automatic Start")}
                  </label>
                  <h4 className="font-roboto text-[20px] text-[#424242]">
                    {detail?.automatic_start_trip
                      ? "Automatic - " + detail?.start_trip_time
                      : "Manual"}
                  </h4>
                </div>
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-[14px] text-[#818181]">
                    {t("Delivery Status")}
                  </label>
                  <h4 className="font-roboto text-[20px] text-[#424242]">
                    {detail?.delivery_status ? detail?.delivery_status : "-"}
                  </h4>
                </div>
              </div>
              <div className="gap-[40px] mb-[24px]">
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-[14px] text-[#818181]">
                    {t("Planned Delivery Time")}
                  </label>
                  <h4 className="font-roboto text-[20px] text-[#424242]">
                    {detail?.planned_delivery_time ? detail?.planned_delivery_time : "-"}
                  </h4>
                </div>
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-[14px] text-[#818181]">
                    {t("Shipping Cost")}
                  </label>
                  <h4 className="font-roboto text-[20px] text-[#424242]">
                    Rp. {detail?.shipping_cost}
                  </h4>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="flex flex-col gap-[40px]">
          <div>
            <CustomDivider name={"Customer Information"} />
            <div className="flex">
              {/* line one */}
              <div className="gap-[40px] mb-[24px]">
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-[14px] text-[#818181]">
                    {t("Customer ID")}
                  </label>
                  <h4 className="font-roboto text-[20px] text-[#424242]">
                    {detail?.customer_id ? detail?.customer_id : "-"}
                  </h4>
                </div>
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-[14px] text-[#818181]">
                    {t("Customer Phone")}
                  </label>
                  <h4 className="font-roboto text-[20px] text-[#424242]">
                    {detail?.customer_phone ? detail?.customer_phone : "-"}
                  </h4>
                </div>
              </div>
              {/* line two */}
              <div className="gap-[40px] mb-[24px]">
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-[14px] text-[#818181]">
                    {t("Customer Name")}
                  </label>
                  <h4 className="font-roboto text-[20px] text-[#424242]">
                    {detail?.customer_first_name} {detail?.customer_last_name}
                  </h4>
                </div>
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-[14px] text-[#818181]">
                    {t("Customer Fax")}
                  </label>
                  <h4 className="font-roboto text-[20px] text-[#424242]">
                    {detail?.customer_fax ? detail?.customer_fax :"-"}
                  </h4>
                </div>
              </div>
              {/* line three */}
              <div className="gap-[40px] mb-[24px]">
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-[14px] text-[#818181]">
                    {t("Customer Email")}
                  </label>
                  <h4 className="font-roboto text-[20px] text-[#424242]">
                    {detail?.customer_email ? detail?.customer_email : "-"}
                  </h4>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="flex flex-col gap-[40px]">
          <div>
            <CustomDivider name={"Customer Address"} />
            <div className="flex">
              {/* line one */}
              <div className="gap-[40px] mb-[24px]">
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-[14px] text-[#818181]">
                    {t("Country")}
                  </label>
                  <h4 className="font-roboto text-[20px] text-[#424242]">
                    {detail?.country_name ? detail?.country_name : "-"}
                  </h4>
                </div>
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-[14px] text-[#818181]">
                    {t("Sub District")}
                  </label>
                  <h4 className="font-roboto text-[20px] text-[#424242]">
                    {detail?.sub_district_name ? detail?.sub_district_name : "-"}
                  </h4>
                </div>
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-[14px] text-[#818181]">
                    {t("Neighbourhood")}
                  </label>
                  <h4 className="font-roboto text-[20px] text-[#424242]">
                    {detail?.neighbourhood ? detail?.neighbourhood : "-"}
                  </h4>
                </div>
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-[14px] text-[#818181]">
                    {t("Longitude")}
                  </label>
                  <h4 className="font-roboto text-[20px] text-[#424242]">
                    {detail?.longitude ? detail?.longitude : "-"}
                  </h4>
                </div>
            <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-[14px] text-[#818181]">
                    {t("Pinpoin")}
                  </label>
                  <MapsSmall
                    long={detail?.longitude}
                    lat={detail?.latitude}
                    onClicks={() => setIsOpenMaps(true)}
                  />
                </div>
              </div>
              {/* line two */}
              <div className="gap-[40px] mb-[24px]">
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-[14px] text-[#818181]">
                    {t("Province")}
                  </label>
                  <h4 className="font-roboto text-[20px] text-[#424242]">
                    {detail?.province_name ? detail?.province_name : "-"}
                  </h4>
                </div>
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-[14px] text-[#818181]">
                    {t("Urban Village")}
                  </label>
                  <h4 className="font-roboto text-[20px] text-[#424242]">
                    {detail?.urban_village_name ? detail?.urban_village_name : "-"}
                  </h4>
                </div>
                
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-[14px] text-[#818181]">
                    {t("Hamlet")}
                  </label>
                  <h4 className="font-roboto text-[20px] text-[#424242]">
                    {detail?.hamlet ? detail?.hamlet : "-"}
                  </h4>
                </div>
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-[14px] text-[#818181]">
                    {t("Latitude")}
                  </label>
                  <h4 className="font-roboto text-[20px] text-[#424242]">
                    {detail?.latitude ? detail?.latitude : "-"}
                  </h4>
                </div>
              </div>
              {/* line three */}
              <div className="gap-[40px] mb-[24px]">
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-[14px] text-[#818181]">
                    {t("District")}
                  </label>
                  <h4 className="font-roboto text-[20px] text-[#424242]">
                    {detail?.district_name ? detail?.district_name : "-"}
                  </h4>
                </div>
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-[14px] text-[#818181]">
                    {t("Address")}
                  </label>
                  <h4 className="font-roboto text-[20px] text-[#424242]">
                    {detail?.address ? detail?.address : "-"}
                  </h4>
                </div>
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-[14px] text-[#818181]">
                    {t("Postal Code")}
                  </label>
                  <h4 className="font-roboto text-[20px] text-[#424242]">
                    {detail?.postal_code ? detail?.postal_code : "-"}
                  </h4>
                </div>
              </div>
            </div>
            
          </div>
        </div>
      </>
    );
  };

  const items = [
    {
      key: 1,
      label: t("Order Detail"),
      children: Order(),
    },
    {
      key: 2,
      label: t("Delivery Detail"),
      children: Delivery(),
    },
  ];
  const doPost = async (endpoint, tkn, data, dispatch, refresh_token) => {
    // const api = `http://app.sbp:9038/v1/grolog`;
    const api = GROLOG_ORDER_URL;

    const url = api + endpoint;
    const method = "POST";
    const headers = {
      Authorization: token,
    };
    const request = { url, method, headers, data };
    return axios(request);
  };
  const onApproveReject = async (result) => {
    let cek = [{id:location.state, updated_at: detail.updated_at}];
    // let id=
    // dataCheck?.map((el) => {
    //   cek.push({
    //     id: el.order_id,
    //     updated_at: el.updated_at,
    //   });
    // });
    let list_trip = { list_gromart_order: cek };

    try {
      let tkn = token;
      let res = await doPost(`/gromart-order/${result}?${param}`, tkn, list_trip);
      // setSuccessModalOpen(true);
      // message.success(_.startCase("Success Start Trip"));
      setMessages("Success Approve");
      // setDataCheck([]);
      setSuccessModalOpen(true);
      setStartOpen(false);
    } catch (err) {
      if (
        err.response.data.payload.message ===
        "Data with this Additional Name is already used by other, cant process this action"
      ) {
        // setErr(err.response.data.payload.message)
      } else {
        // message.error(_.startCase(err.response.data.payload.message));
        setMessages(err.response.data.payload.message);
        setFailedModalOpen(true);
        setStartOpen(false);
      }
    }
  };
  const actModal = () => {
    setSuccessModalOpen(false);
    setFailedModalOpen(false);
    setStartOpen(false);
    setEndOpen(false);
    setMessages("");
    fetchData();
    navigate(ROUTES.GROMART_ORDER.LIST)
  };
  return (
    <>
       <ModalStartEndTrip
        visible={startOpen}
        styles={" w-[200px] ml-[-20px]"}
        message={`Are you sure want to approve`}
        title={"Approve Order?"}
        titles="Approve"
        message2={detail?.customer_first_name + " - "+detail?.order_group_id+"?"}
        onClick={() => onApproveReject("approve")}
        action={() => setStartOpen(false)}
      />
      <ModalStartEndTrip
        visible={endOpen}
        styles={" w-[200px] ml-[-20px]"}
        message2={detail?.customer_first_name + " - "+detail?.order_group_id+"?"}
        message={`Are you sure want to reject`}
        title={"Reject Order?"}
        titles="Reject"
        onClick={() =>onApproveReject("reject")}
        action={() => setEndOpen(false)}
      />
      <ModalSuccessAdd
        show={successModalOpen}
        action={() => actModal()}
        closable={false}
        width={280}
        className={style.deleteModal}
        okText="Ok"
        title="Success"
        description={messages}
      />
      <div className="p-[24px] flex flex-col gap-[24px]">
        <div>
          <Breadcumbs
            jmlLevel={3}
            menuLevel1={`Order`}
            menuLevel2={`GroMart Order`}
            menuLevel3={
              `Detail ` + detail?.order_id + " - " + detail?.order_group_id
            }
          />
        </div>

        <div className="flex items-center justify-between">
          <div
            onClick={() => navigate(ROUTES.GROMART_ORDER.LIST)}
            className="cursor-pointer flex items-center gap-[22px]"
          >
            <img src={BackIcon} alt="" className="cursor-pointer" />
            <h1 className="font-sans-bold text-2xl" id="title">
              Detail {detail?.order_id + " - " + detail?.order_group_id}
            </h1>
            <img
              src={
                detail?.order_status === "Approved"
                  ? ApproveIcon
                  : detail?.order_status === "Rejected"
                  ? RejectedIcon
                  : WaitApproveIcon
              }
              alt="status"
            />
          </div>
          <div
            className="bg-[#EEEEEE] rounded-[6px] px-[12px] py-[7px] cursor-pointer"
            onClick={() => setUserManagementOpen(true)}
          >
            <p className="text-[#666666]">
              {t("USER_DETAIL:CREATED_BY")}{" "}
              <strong>{detail?.created_by}</strong> {t("USER_DETAIL:ON")}{" "}
              <strong>{convertTimestamp(detail?.created_at, true)}</strong> |{" "}
              {t("USER_DETAIL:LAST_MODIFIED_BY")}{" "}
              <strong>{detail?.updated_by}</strong> {t("USER_DETAIL:ON")}{" "}
              <strong>{convertTimestamp(detail?.updated_at, true)}</strong>
            </p>
          </div>
        </div>

        <div
          style={{
            marginTop: 24,
            padding: 30,
            minHeight: 512,
            borderRadius: "6px",
            backgroundColor: "white",
            boxShadow: "0px 3px 6px rgba(0, 0, 0, 0.16)",
          }}
        >
          <div className={style.tabsContainer + ""}>
            <Tabs
              defaultActiveKey="1"
              items={items}
              className="border-b border-[#ffffff]"
            />
          </div>
        </div>
        <ManagementHistory
          id={detail?.order_id}
          detail={detail}
          tableName={"gromart_order"}
          userManagementOpen={userManagementOpen}
          setUserManagementOpen={() => setUserManagementOpen(false)}
        />
        <div className="flex flex-row-reverse gap-[16px]">
          
        {detail?.order_status ==="Waiting For Approval" ?
        <>
        <PrimaryButton
          // text={t("USER_DETAIL:CANCEL")}
          // action={() => props.action()}
          text={"Approve Order"}
          action={() => setStartOpen(true)}
        />
        <SecondaryButton
            // styles={props.styles}
            //   text={t("Yes, ")+props.title}
            text={t("Reject Order")}
            action={() => setEndOpen(true)}
            />
            </>
            
          : <></>
}
        </div>
      </div>
    </>
  );
};

export default GromartOrderRequestDetail;
